module.exports = __webpack_public_path__ + "img/partner-cover-2.ab8b671b.jpg";